import React from 'react'
import { Spinner } from 'react-bootstrap'

function Spin() {
    return (
        <div style={{ fontSize:'16px',color:'blue',fontFamily:'Kanit',width: '100%',zIndex:'9999', height: '100vh', background:'rgba(0,0,0,0.01)', position: 'fixed', top: 0, left: 0, display: 'flex',flexDirection:'column', alignItems: 'center', justifyContent: 'center' }}>
            <Spinner animation="border" variant="primary" />
            processing....
        </div>
    )
}

export default Spin
